import { ConsentInput } from "@/vue/services/cmp/CmpConsentBackendService";
import { CmpConsentDecisionToDomain } from "@/vue/services/cmp/CmpModel";

export function buildGetConsentRequest(
  registrationId?: string,
  accountId?: string
) {
  return `{
      getConsent(user: { ${insertRegistrationIdIfProceeds(registrationId)}
       ${insertAccountIdIfProceeds(accountId)}})
      ${buildResponseFields()}
    }`;
}

export function getStoreConsentMutationRequest(
  consentInput: ConsentInput,
  allDecisions?: CmpConsentDecisionToDomain[] | undefined
) {
  return `mutation {
  storeConsent(
    consent: {
      ${insertRegistrationIdIfProceeds(consentInput.registrationId)}
      ${insertAccountIdIfProceeds(
        consentInput.accountId,
        consentInput.customerId
      )}
      uCControllerId: {
        controllerId: "${consentInput.uCControllerId.controllerId}",
        uCConfigurationId: "${consentInput.uCControllerId.uCConfigurationId}"
       }
      ${insertArrayOfConsentsIfProceeds(consentInput, allDecisions)}
    }
  )
  ${buildResponseFields()}
  }`;
}

function insertRegistrationIdIfProceeds(
  registrationId: string | undefined
): string {
  if (registrationId) {
    return `registrationId: "${registrationId}",`;
  }
  return "";
}

function insertAccountIdIfProceeds(
  accountId?: string,
  customerId?: string
): string {
  const value = accountId || customerId;
  if (value) {
    return `accountId: "${value}",`;
  }
  return "";
}

function insertArrayOfConsentsIfProceeds(
  consentInput: ConsentInput,
  allDecisions?: CmpConsentDecisionToDomain[]
): string {
  if (!consentInput.accountId || !allDecisions) {
    return "";
  }
  const arrayOfConsentsString = allDecisions.map(consent => {
    return `
    {
        code: "${consent.service.split(" ")[0]}",
        name: "${consent.service
          .split(" ")
          .slice(1)
          .join(" ")}",
        selected: ${consent.consent}
    }`;
  });
  return `,consents: [ ${arrayOfConsentsString.join()} ]`;
}

function buildResponseFields() {
  return `{
    controllerId
    uCConfigurationId
    createdAt
    modifiedAt
  }`;
}
